module.exports = __webpack_public_path__ + "static/media/private_entrance.3ee6c3fc.svg";